import { render, staticRenderFns } from "./Vue2Editor.vue?vue&type=template&id=7214590e&"
import script from "./Vue2Editor.vue?vue&type=script&lang=js&"
export * from "./Vue2Editor.vue?vue&type=script&lang=js&"
import style0 from "./Vue2Editor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VRow,VSnackbar})
